import React, { Component } from 'react';

class UserSliderInputTextil extends Component{
  constructor(props) {
    super(props);
    this.state = {
      leftLabel: this.props.white,
      rightLabel: this.props.colourful
    }
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const value = e.target.value;
    this.props.onChange(value);
    this.setLabels(value)
  }

  setLabels = (value) => {
    if(value > 50 && this.state.rightLabel !== this.props.dark){
      this.setState({
        rightLabel: this.props.dark
      })
    }
    else if(value <= 50 && this.state.rightLabel !== this.props.colourful){
      this.setState({
        rightLabel: this.props.colourful
      })
    }
  }

  componentDidMount = () => {
    const value = this.props.value;
    this.props.onChange(value)
    this.setLabels(value)
  }

  render() {
    const styles = this.props.styles

    return(
      <div key={this.props.name} className={styles.inputItem}>
          <div className={styles.info}>
            {this.props.label}
          </div>
          <p>{this.props.helpText}</p>
          <div className={styles.slider}>
            <aside className={styles.sliderData}>
              <i>{100 - this.props.value}{this.props.showPercentage && "%"}</i>
              <i>{this.props.value}{this.props.showPercentage && "%"}</i>
            </aside>
            <input onChange={this.handleChange} type="range"
              name={this.props.name}
              value={this.props.value}
              max="100"
              min="0"
              step="1"
            />
            <aside>
              <i>{this.props.white}</i>
              <i>{this.state.rightLabel}</i>
            </aside>
          </div>
      </div>
      
    );
  }
}

export default UserSliderInputTextil;



// WEBPACK FOOTER //
// ./src/components/calculator/step-by-step/s_slider_textil.js